import { view, layout } from "@/mega-ui/helpers/function"
import { loginUuidGuard, enterRenewAccessGuard, recoverPasswordEmailGuard } from "@/helpers/routerHelpers"

export const login = {
    path: '/login',
    name: 'login',
    component: () => layout('EmptyLayout'),
    children: [
        {
            path: '',
            name: 'login-main',
            component: () => view('login/LoginView')
        },
        {
            path: 'recover-password',
            name: 'recover-password',
            props: { recoverPassword: true },
            component: () => view('login/LoginView')
        },
        {
            path: 'recover-password/sms',
            name: 'recover-password-phone',
            component: () => view('login/recover/RecoverPasswordSmsView')
        },
        {
            path: 'recover-password/:uuid([0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})/:token',
            name: 'recover-password-email',
            beforeEnter: [ recoverPasswordEmailGuard ],
            component: () => view('login/recover/RecoverPasswordTokenView')
        },
        {
            path: 'create-password/:uuid([0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})/:token',
            name: 'create-password-email',
            beforeEnter: [ recoverPasswordEmailGuard ],
            props: { isCreatePassword: true },
            component: () => view('login/recover/RecoverPasswordTokenView')
        },
        {
            path: 'create-account',
            name: 'create-account-msisdn',
            component: () => view('login/CreateAccountView')
        },
        {
            path: 'renew',
            name: 'renew-access',
            beforeEnter: [ enterRenewAccessGuard ],
            component: () => view('login/RenewAccessView')
        },
        {
            path: ':uuid([0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})/:token',
            name: 'relog-main',
            beforeEnter: [ loginUuidGuard ],
            component: () => view('login/LoginView')
        },
    ]
}